const pickerSelector = 'input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"], input[type="week"]';

export const setupRcdDateTimeInputs = (root = document) => {
    root.querySelectorAll(pickerSelector).forEach((input) => {
        if (input.dataset.rcdDatetimeReady === "true") {
            return;
        }

        input.dataset.rcdDatetimeReady = "true";
        input.addEventListener("click", () => {
            if (typeof input.showPicker === "function" && !input.disabled && !input.readOnly) {
                try {
                    input.showPicker();
                } catch {
                    // Some browsers reject showPicker() outside a direct user gesture; the
                    // native picker indicator click still works as a fallback in that case.
                }
            }
        });
    });
};
